import {
	agentActivitySchema,
	devActivitySchema,
	scalabilitySchema,
	financialsSchema,
	cardMetricsSchema,
} from './schema'

export const CARD_METRICS_RANGE_OPTIONS: {
	label: string
	value: ReturnType<typeof cardMetricsSchema.parse>['range-cm']
}[] = [
	{
		label: '1 day',
		value: 'day',
	},
	{
		label: '7 days',
		value: 'week',
	},
	{
		label: '30 days',
		value: 'month',
	},
]

export const SCALABILITY_RANGE_OPTIONS: {
	label: string
	value: ReturnType<typeof scalabilitySchema.parse>['range-cm']
}[] = [
	{
		label: '1 hour',
		value: 'hour',
	},
	{
		label: '1 day',
		value: 'day',
	},
	{
		label: '7 days',
		value: 'week',
	},
	{
		label: '30 days',
		value: 'month',
	},
]

export const DEV_ACTIVITY_RANGE_OPTIONS: {
	label: string
	value: ReturnType<typeof devActivitySchema.parse>['range-dm']
}[] = [
	{
		label: '7 days',
		value: 'week',
	},
	{
		label: '30 days',
		value: 'month',
	},
	{
		label: 'All time',
		value: 'all-time',
	},
]

export const AGENTS_ACTIVITY_RANGE_OPTIONS: {
	label: string
	value: ReturnType<typeof agentActivitySchema.parse>['range-am']
}[] = [
	{
		label: '1 day',
		value: 'day',
	},
	{
		label: '7 days',
		value: 'week',
	},
	{
		label: '30 days',
		value: 'month',
	},
	{
		label: 'All time',
		value: 'all-time',
	},
]

export const FINANCIALS_RANGE_OPTIONS: {
	label: string
	value: ReturnType<typeof financialsSchema.parse>['range-fm']
}[] = [
	{
		label: '1 day',
		value: 'day',
	},
	{
		label: '7 days',
		value: 'week',
	},
	{
		label: '30 days',
		value: 'month',
	},
]
